import axios, {AxiosResponse} from 'axios'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {ICorporateModel, ICorporateRequest, ICorporateUserModel} from './CorporateModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

/** Gateway'deki firma yönetimi; yalnızca ADMIN rolü erişebilir */
const ADMIN_CORPORATE_URL = `${API_URL}api/v1/corporate/admin/`

export function loadCorporates(
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<ICorporateModel>>>> {
  return axios.get(`${ADMIN_CORPORATE_URL}getAll`, {params: {page, size}})
}

export function createCorporate(
  request: ICorporateRequest
): Promise<AxiosResponse<ApiResponse<ICorporateModel>>> {
  return axios.post(`${ADMIN_CORPORATE_URL}create`, request)
}

export function updateCorporate(
  corporateId: string,
  request: ICorporateRequest
): Promise<AxiosResponse<ApiResponse<ICorporateModel>>> {
  return axios.patch(`${ADMIN_CORPORATE_URL}update/${corporateId}`, request)
}

export function setCorporateActive(
  corporateId: string,
  active: boolean
): Promise<AxiosResponse<ApiResponse<ICorporateModel>>> {
  return axios.patch(`${ADMIN_CORPORATE_URL}setActive/${corporateId}`, null, {params: {active}})
}

export function deleteCorporate(corporateId: string) {
  return axios.delete(`${ADMIN_CORPORATE_URL}delete/${corporateId}`)
}

export function loadCorporateUsers(
  corporateId: string
): Promise<AxiosResponse<ApiResponse<ICorporateUserModel[]>>> {
  return axios.get(`${ADMIN_CORPORATE_URL}${corporateId}/users`)
}

export function assignCorporateUser(corporateId: string, email: string, defaultCorporate: boolean) {
  return axios.post(`${ADMIN_CORPORATE_URL}${corporateId}/users`, {email, defaultCorporate})
}

export function removeCorporateUser(corporateId: string, userId: string) {
  return axios.delete(`${ADMIN_CORPORATE_URL}${corporateId}/users/${userId}`)
}
